import useAutoCenter from './hooks/internal/useAutoCenter.js';

const AutoCenter = () => {
  useAutoCenter();

  return false;
};

export default AutoCenter;
